import React from "react";
import { Box, Dialog, IconButton, Theme, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NewReleasesIcon from "@mui/icons-material/NewReleases";

/* region Languages */
import { CustomerMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
/* endregion Languages */

import { VERSION_DETAILS_URL } from "./versionDetails";

// 5% of breathing room on every side, so it reads as a dialog over the page
const paperSx = {
  display: "flex",
  flexDirection: "column",
  width: "90vw",
  height: "90vh",
  maxWidth: "none",
  maxHeight: "none",
  m: 0,
  borderRadius: "10px",
  overflow: "hidden"
};

interface VersionDetailsDialogProps {
  open: boolean;
  /** Shown in the bar and used as the iframe title */
  title: string;
  /** Route of the details page, without the "#" */
  hash: string;
  onClose: () => void;
}

/** Large dialog that shows "Novidades em detalhe" on a version or an interval */
const VersionDetailsDialog: React.FC<VersionDetailsDialogProps> = ({ open, title, hash, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog maxWidth={false} open={open} onClose={onClose} PaperProps={{ sx: paperSx }} aria-labelledby="version-details-title">
      <Box
        sx={(theme: Theme) => ({
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          py: 1,
          pr: 1,
          pl: 2.5,
          borderBottom: `1px solid ${theme.palette.divider}`,
          color: theme.palette.primary.main
        })}
      >
        <NewReleasesIcon />
        <Typography id="version-details-title" sx={{ flex: 1, fontSize: 16, fontWeight: 600, color: "text.primary" }}>{title}</Typography>
        <IconButton aria-label={t(CustomerMessages.docsClose)} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {open && (
        <Box component="iframe" sx={{ flex: 1, width: "100%", border: 0, display: "block" }} title={title} src={`${VERSION_DETAILS_URL}#${hash}`} />
      )}
    </Dialog>
  );
};

export default VersionDetailsDialog;
